export default "__VITE_ASSET__SDA8YQu3__"